import React from "react";

export const FeaturedProjects = (props) => {
  const data = props.data;

  return (
    <div id="portfolio">
      <div className="container">
        <div className="section-title">
          <h2>{data ? data.title : "Live Projects"}</h2>
          <p>{data ? data.subtitle : ""}</p>
        </div>
        <div className="row">
          {data && data.items
            ? data.items.map((item, i) => (
                <div key={`${item.title}-${i}`} className="col-md-6">
                  <div className="featured-card">
                    <div className="featured-card-image">
                      <img src={item.image} alt={item.title} />
                      <span className="live-badge">● LIVE</span>
                    </div>
                    <div className="featured-card-body">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <div className="tech-tags">
                        {item.tags &&
                          item.tags.map((tag, idx) => (
                            <span key={`${tag}-${idx}`} className="tech-tag">
                              {tag}
                            </span>
                          ))}
                      </div>
                      <a
                        href={item.url}
                        className="btn btn-custom"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Visit Live →
                      </a>
                    </div>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
